import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedAnime from './components/FeaturedAnime';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    document.title = '奶泡动漫 - 高清动漫在线观看平台 | 最新番剧、国漫日漫免费看';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '奶泡动漫是专注于高清动漫在线观看的平台，提供最新番剧、经典动漫、国漫、日漫海量资源，支持多端播放，画质清晰流畅，让每一位动漫爱好者享受极致追番体验。');
    }
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) {
      metaKw.setAttribute('content', '奶泡动漫,奶泡动漫在线观看,奶泡动漫最新番剧,奶泡动漫高清播放,奶泡动漫国漫日漫,动漫在线免费观看,最新动漫推荐2025');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', window.location.origin + '/');
    }
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '奶泡动漫',
        url: window.location.origin,
        description: '专注于高清动漫在线观看的平台，提供最新番剧、经典动漫、国漫、日漫海量资源。',
        sameAs: [],
      },
      {
        '@type': 'WebSite',
        name: '奶泡动漫',
        url: window.location.origin,
      },
      {
        '@type': 'WebPage',
        name: '奶泡动漫 - 高清动漫在线观看平台',
        description: '奶泡动漫是专注于高清动漫在线观看的平台，提供最新番剧、经典动漫、国漫、日漫海量资源。',
        url: window.location.origin + '/',
        isPartOf: {
          '@type': 'WebSite',
          name: '奶泡动漫',
          url: window.location.origin,
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedAnime />
        <CategorySection />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}